import { render, staticRenderFns } from "./Integralrule.vue?vue&type=template&id=b8090b4c&scoped=true&"
import script from "./Integralrule.vue?vue&type=script&lang=js&"
export * from "./Integralrule.vue?vue&type=script&lang=js&"
import style0 from "./Integralrule.vue?vue&type=style&index=0&id=b8090b4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8090b4c",
  null
  
)

export default component.exports